/* Sticky ATC /////////////////*/

document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.getElementById('sticky-atc');
  const productForm = document.querySelector('form.product-page--form');

  if (!sticky || !productForm) return;

  // Real elements in main form (source of truth)
  const mainAtcBtn = productForm.querySelector('.product-buy-buttons--primary');
  const mainSizeRadios = productForm.querySelectorAll(
    '.radios--input[data-option-name="size"]'
  );

  // Fake elements in sticky bar
  const stickyAtcBtn = sticky.querySelector('.sticky-atc__button');
  const stickySizeBtns = sticky.querySelectorAll('.sticky-atc__size-btn');

  if (!mainAtcBtn || !mainSizeRadios.length || !stickyAtcBtn || !stickySizeBtns.length) return;

  const stickyAtcLabelEl =
    stickyAtcBtn.querySelector('.sticky-atc__button-text') || stickyAtcBtn;

  const defaultStickyLabel =
    stickyAtcBtn.getAttribute('data-text') ||
    stickyAtcLabelEl.textContent.trim() ||
    'Add to cart';

  const outOfStockLabel =
    stickyAtcBtn.getAttribute('data-out-of-stock-text') || 'Out of stock';

  // --- availability map from original size labels (by value) ---
  function buildAvailabilityMap() {
    const map = {};
    document.querySelectorAll('.radios--value-button').forEach((label) => {
      const input = label.querySelector(
        '.radios--input[data-option-name="size"]'
      );
      if (!input) return;
      const value = input.value;
      const unavailable = label.dataset.unavailable === 'true';
      map[value] = unavailable;
    });
    return map;
  }

  function getMainSelectedSize() {
    const checked = productForm.querySelector(
      '.radios--input[data-option-name="size"]:checked'
    );
    return checked ? checked.value : null;
  }

  // --- 1. sticky sizes: active + unavailable states ---

  function syncStickySizes() {
    const availabilityMap = buildAvailabilityMap();
    const current = getMainSelectedSize();

    stickySizeBtns.forEach((btn) => {
      const value = btn.dataset.sizeValue;

      // active
      const isActive = value === current;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      // unavailable
      const unavailable = !!availabilityMap[value];
      btn.classList.toggle('is-unavailable', unavailable);
      btn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      // if you want to hard-disable click on sold-out sizes, uncomment:
      // btn.disabled = unavailable;
    });
  }

  // --- 2. sticky CTA state (enabled/disabled + label) ---

  function isCurrentVariantUnavailable() {
    const availabilityMap = buildAvailabilityMap();
    const currentSize = getMainSelectedSize();

    // From label map (most reliable)
    const bySize =
      currentSize && Object.prototype.hasOwnProperty.call(availabilityMap, currentSize)
        ? availabilityMap[currentSize]
        : false;

    // Extra safety: also look at main button
    const byDisabled = mainAtcBtn.disabled;
    const byText = /out of stock/i.test(mainAtcBtn.textContent);

    return !!(bySize || byDisabled || byText);
  }

  function updateStickyCtaState() {
    const unavailable = isCurrentVariantUnavailable();

    stickyAtcBtn.disabled = unavailable;
    stickyAtcBtn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    if (unavailable) {
      stickyAtcLabelEl.textContent = outOfStockLabel;
    } else {
      stickyAtcLabelEl.textContent = defaultStickyLabel;
    }
  }

  // --- 3. sticky → main size change wiring ---

  function syncMainFromSticky(sizeValue) {
    const selector =
      '.radios--input[data-option-name="size"][value="' + sizeValue + '"]';
    const target = productForm.querySelector(selector);

    if (target && !target.disabled) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  stickySizeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = btn.dataset.sizeValue;
      syncMainFromSticky(value);
      syncStickySizes();
      updateStickyCtaState();
    });
  });

  mainSizeRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      syncStickySizes();
      updateStickyCtaState();
    });
  });

  // Initial state on load
  syncStickySizes();
  updateStickyCtaState();

  // Watch the main ATC for changes (theme may toggle text/disabled)
  const atcObserver = new MutationObserver(updateStickyCtaState);
  atcObserver.observe(mainAtcBtn, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['disabled', 'aria-busy'],
  });

  // --- sticky CTA: delegate to main ---

  stickyAtcBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isCurrentVariantUnavailable()) return;

    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    stickyAtcBtn.setAttribute('aria-busy', 'true');

    mainAtcBtn.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
      stickyAtcBtn.setAttribute('aria-busy', 'false');
    });
  });

  // --- show/hide sticky based on scroll ---

  function handleScroll() {
    const rect = mainAtcBtn.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      sticky.classList.remove('is-visible');
    } else {
      sticky.classList.add('is-visible');
    }
  }

  handleScroll();
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
});


/** pdp shpw more swatches */


(function () {
  if (window.__swatchLimiterSimple) return;
  window.__swatchLimiterSimple = true;

  var MAX = 5;
  var CONTAINER_SEL = '.swatches--container[data-linked-plp-swatches="true"]';

  function initContainer(container) {
    if (container.dataset.expanded === 'true') return;
    if (container.dataset.limited === 'true') return;

    var swatches = Array.from(container.querySelectorAll('label.swatch'));
    if (swatches.length <= MAX) return;

    container.dataset.limited = 'true';

    swatches.forEach(function (s, i) {
      if (i >= MAX) s.style.display = 'none';
    });

    var remaining = swatches.length - MAX;

    var existing = container.querySelector('[data-swatch-more="true"]');
    if (existing) existing.remove();

    var more = document.createElement('span');
    more.className = 'swatch-more';
    more.setAttribute('data-swatch-more', 'true');
    more.setAttribute('role', 'button');
    more.setAttribute('tabindex', '0');
    more.setAttribute('aria-label', 'Show ' + remaining + ' more options');
    more.textContent = '+' + remaining;

    function expand(e) {
      e.preventDefault();
      e.stopPropagation();
      container.dataset.expanded = 'true';
      swatches.forEach(function (s) { s.style.display = ''; });
      more.remove();
    }

    more.addEventListener('click', expand);
    more.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') expand(e);
    });

    container.appendChild(more);
  }

  function initAll() {
    document.querySelectorAll(CONTAINER_SEL).forEach(initContainer);
  }

  initAll();
  var mo = new MutationObserver(initAll);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/**
  Goal:
  - Theme quickview ALWAYS opens normally.
  - We pre-inject an empty slot into the OG quickview container as soon as it exists.
  - If a swatch was clicked on that card: after QV opens, we inject swatch-specific markup into the slot
    and hide the OG content (CSS toggle).
  - If no swatch was clicked: ensure OG content is visible and swatch slot hidden.
*/

(function() {
  if (window.__SWATCH_QV_SLOT_COMBINED__) return;
  window.__SWATCH_QV_SLOT_COMBINED__ = true;

  const LOG = (...a) => console.log("%c[swatch-qv]", "color:#22c55e;font-weight:900", ...a);
  const WRN = (...a) => console.warn("%c[swatch-qv]", "color:#f59e0b;font-weight:900", ...a);

  /* =========================
     SELECTORS
  ========================== */
  const CARD_SEL = '[data-product-item], .product--root, .product-item, .grid-product, .product-card, li, article';
  const LINKED_SWATCH_SEL =
    '.swatches--container[data-linked-plp-swatches="true"] label.swatch,' +
    '.swatches--container[data-linked-plp-swatches="true"] .swatch';

  const QUICKVIEW_BTN_SEL = [
    'button.product--quick-add--button',
    '[data-quick-view]', '[data-quickview]',
    '[data-quick-add]', '[data-quickadd]',
    '.quick-view', '.quickview', '.product-quickview'
  ].join(',');

  const OG_CONTAINER_SEL = '.drawer--container[data-view="product-form"]';

  const SLOT_ID = 'swatch-qv-slot';
  const SLOT_CLASS = 'swatch-qv-slot';

  /* =========================
     CSS: visibility toggles only
  ========================== */
  function ensureStyles() {
    if (document.getElementById("swatch-qv-slot-styles")) return;
    const style = document.createElement("style");
    style.id = "swatch-qv-slot-styles";
    style.textContent = `
      /* during ATC we keep product-form hidden to prevent OG flash */
      ${OG_CONTAINER_SEL}.swatch-qv-atc-pending { visibility:hidden !important; }

      #${SLOT_ID}.${SLOT_CLASS} { display:none; }
      #${SLOT_ID}.${SLOT_CLASS}.is-active { display:block; }

      .swatch-qv-hide-og > :not(#${SLOT_ID}) { display:none !important; }
    `;
    document.head.appendChild(style);
  }

  /* =========================
     CARD UPDATE HELPERS (your original behavior)
  ========================== */
  function ensureOriginalData(card, link, mainImage, hoverImage, titleEl) {
    if (!card.dataset.originalHref) card.dataset.originalHref = link.getAttribute('href') || '';
    if (!card.dataset.originalSrc && mainImage) card.dataset.originalSrc = mainImage.getAttribute('src') || '';
    if (!card.dataset.originalHoverSrc && hoverImage) card.dataset.originalHoverSrc = hoverImage.getAttribute('src') || '';
    if (!card.dataset.originalTitle && titleEl) card.dataset.originalTitle = titleEl.textContent.trim();
  }

  function preloadImage(url) {
    return new Promise(function(resolve, reject) {
      if (!url) return resolve(null);
      var img = new Image();
      img.onload = function() { resolve(url); };
      img.onerror = function() { reject(url); };
      img.src = url;
    });
  }

  /* =========================
     PRODUCT HANDLE + FETCH HELPERS
  ========================== */
  const handleFromUrl = (url) => {
    const m = String(url || "").match(/\/products\/([^/?#]+)/);
    return m ? m[1] : "";
  };

  async function fetchText(url) {
    const r = await fetch(url, { credentials: "same-origin" });
    if (!r.ok) throw new Error("Fetch failed " + r.status + " " + url);
    return r.text();
  }

  function extractQuickAddInner(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const wrap =
      doc.querySelector(".product--quick-add--form") ||
      doc.querySelector("product-options-element")?.closest("form")?.parentElement ||
      doc.querySelector("form.shopify-product-form");
    return wrap ? wrap.outerHTML : null;
  }

  async function fetchQuickAdd(handle) {
    const sections = [
      "product--quick-add--form",
      "product-quick-add",
      "quick-add",
      "quickview",
      "product-form"
    ];

    for (const s of sections) {
      try {
        const html = await fetchText(`/products/${handle}?section_id=${encodeURIComponent(s)}`);
        const out = extractQuickAddInner(html);
        if (out) return out;
      } catch {}
    }

    try {
      const html = await fetchText(`/products/${handle}`);
      return extractQuickAddInner(html);
    } catch {}

    return null;
  }

  /* =========================
     OG QV SLOT MANAGEMENT
  ========================== */
  function ensureSlot(container) {
    ensureStyles();
    if (!container) return null;

    let slot = container.querySelector("#" + SLOT_ID);
    if (!slot) {
      slot = document.createElement("div");
      slot.id = SLOT_ID;
      slot.className = SLOT_CLASS;
      container.prepend(slot); // keep it first so :not(#slot) hides everything else cleanly
      LOG("Injected empty swatch slot into OG quickview container");
    }
    return slot;
  }

  function showSlot(container, slot) {
    if (!container || !slot) return;
    slot.classList.add("is-active");
    container.classList.add("swatch-qv-hide-og");
  }

  function hideSlot(container, slot) {
    if (!container || !slot) return;
    slot.classList.remove("is-active");
    container.classList.remove("swatch-qv-hide-og");
  }

  function waitForOgContainer(timeoutMs = 2000) {
    const start = performance.now();
    return new Promise((resolve) => {
      function tick() {
        const c = document.querySelector(OG_CONTAINER_SEL);
        if (c) return resolve(c);
        if (performance.now() - start > timeoutMs) return resolve(null);
        requestAnimationFrame(tick);
      }
      tick();
    });
  }

  async function bootstrapSlot() {
    const container = await waitForOgContainer(2000);
    if (!container) return;
    ensureSlot(container);
  }

  // Create slot as soon as OG container exists (theme may render it after first open)
  bootstrapSlot();
  new MutationObserver(() => bootstrapSlot()).observe(document.documentElement, { childList: true, subtree: true });

  /* =========================
     BADGE SYNC (drop-in)
     - Adds "Out of stock" badge only if ALL variants unavailable
     - Removes it otherwise
  ========================== */
  window.__PLP_BADGE_CACHE__ = window.__PLP_BADGE_CACHE__ || new Map();

  async function getProductJson(handle) {
    if (!handle) return null;
    const cache = window.__PLP_BADGE_CACHE__;
    if (cache.has(handle)) return cache.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then(r => (r.ok ? r.json() : null))
      .catch(() => null);

    cache.set(handle, p);
    return p;
  }

  function isFullyOOS(product) {
    return product?.variants?.length ? product.variants.every(v => !v.available) : false;
  }

  function syncOOSBadge(card, show) {
    let labels = card.querySelector(".product--labels");

    if (show) {
      if (!labels) {
        labels = document.createElement("div");
        labels.className = "product--labels";
        labels.setAttribute("data-item", "overline");
        labels.setAttribute("data-text-color", "body");
        card.prepend(labels);
      }

      let badge = labels.querySelector('[data-label-type="out-of-stock"]');
      if (!badge) {
        badge = document.createElement("div");
        badge.className = "product--label";
        badge.setAttribute("data-background-color", "djp-2");
        badge.setAttribute("data-label-shape", "square");
        badge.setAttribute("data-label-type", "out-of-stock");
        badge.textContent = "Out of stock";
        labels.appendChild(badge);
      }
    } else {
      const badge = labels?.querySelector('[data-label-type="out-of-stock"]');
      if (badge) badge.remove();
      if (labels && !labels.children.length) labels.remove();
    }
  }

  async function syncCardBadgeFromUrl(card, newProductUrl) {
    const handle = handleFromUrl(newProductUrl);
    if (!handle) return;
    const product = await getProductJson(handle);
    if (!product) return;
    syncOOSBadge(card, isFullyOOS(product));
  }

  /* =========================
     1) SWATCH CLICK:
        - Update card (image/link/title)
        - Store handle on card for QV swap
        - Prefetch QV HTML
        - Sync badge
  ========================== */
  document.addEventListener('click', function(e) {
    // ignore "+N" control if present
    if (e.target.closest('[data-swatch-more="true"], .swatch-more')) return;

    var swatch = e.target.closest(LINKED_SWATCH_SEL);
    if (!swatch) return;

    // stop navigating
    e.preventDefault();
    e.stopPropagation();

    var card = swatch.closest(CARD_SEL);
    if (!card) return;

    var link       = card.querySelector('a[href]');
    var mainImage  = card.querySelector('.product--image');
    var hoverImage = card.querySelector('.product--hover-image');
    var titleEl    = card.querySelector('.product--title[data-item="overline"]');

    if (!link || !mainImage) return;

    ensureOriginalData(card, link, mainImage, hoverImage, titleEl);

    var originalHref     = card.dataset.originalHref;
    var originalSrc      = card.dataset.originalSrc;
    var originalHoverSrc = card.dataset.originalHoverSrc || null;
    var originalTitle    = card.dataset.originalTitle || (titleEl ? titleEl.textContent.trim() : '');

    var newUrl      = swatch.getAttribute('data-product-url') || originalHref;
    var newImg      = swatch.getAttribute('data-product-image') || originalSrc;
    var newHoverImg = swatch.getAttribute('data-product-hover-image') || originalHoverSrc;
    var newTitle    = swatch.getAttribute('data-product-title') || originalTitle;

    // Update visible card link + title
    if (newUrl) link.setAttribute('href', newUrl);
    if (titleEl && newTitle) titleEl.textContent = newTitle;

    // Preload then swap images
    mainImage.classList.add('is-loading');
    if (hoverImage) hoverImage.classList.add('is-loading');

    Promise.allSettled([preloadImage(newImg), preloadImage(newHoverImg)])
      .then(function() {
        if (newImg) {
          mainImage.setAttribute('src', newImg);
          if (mainImage.hasAttribute('srcset')) mainImage.removeAttribute('srcset');
        }
        if (hoverImage && newHoverImg) {
          hoverImage.setAttribute('src', newHoverImg);
          if (hoverImage.hasAttribute('srcset')) hoverImage.removeAttribute('srcset');
        }
      })
      .finally(function() {
        var pending = 1 + (hoverImage && newHoverImg ? 1 : 0);
        function done() {
          pending--;
          if (pending <= 0) {
            mainImage.classList.remove('is-loading');
            if (hoverImage) hoverImage.classList.remove('is-loading');
          }
        }
        if (mainImage.complete) done();
        else mainImage.addEventListener('load', done, { once: true });

        if (hoverImage && newHoverImg) {
          if (hoverImage.complete) done();
          else hoverImage.addEventListener('load', done, { once: true });
        }
      });

    // Active state
    card.querySelectorAll('.swatch.is-active').forEach(function(other) {
      other.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    // Store handle for quickview swap
    var handle = handleFromUrl(newUrl);
    if (!handle) return WRN("Could not parse handle from swatch url:", newUrl);

    card.dataset.swatchTouched = "true";
    card.dataset.selectedHandle = handle;
    window.__QV_SELECTED_HANDLE__ = handle;

    // Prefetch markup (optional but good)
    fetchQuickAdd(handle).then(function(html) {
      if (html) card.__swatchQvHtml = html;
    }).catch(function(){});

    // ✅ Badge sync (new)
    syncCardBadgeFromUrl(card, newUrl).catch(()=>{});

    LOG("Swatch updated card + stored handle:", handle);
  }, true);

  /* =========================
     2) QUICKVIEW CLICK:
        DO NOT intercept — let theme open OG QV.
        After open, decide whether to inject/hide OG.
  ========================== */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(QUICKVIEW_BTN_SEL);
    if (!btn) return;

    const card = btn.closest(CARD_SEL);
    if (!card) return;

    const hasActiveSwatch =
      !!card.querySelector('.swatches--container[data-linked-plp-swatches="true"] .swatch.is-active[data-product-url]');
    const isSwatched = (card.dataset.swatchTouched === "true") || hasActiveSwatch;

    const handle = card.dataset.selectedHandle || window.__QV_SELECTED_HANDLE__ || "";

    async function apply(reason) {
      const container = await waitForOgContainer(2000);
      if (!container) return WRN("OG quickview container not found after click:", reason);

      const slot = ensureSlot(container);

      if (!isSwatched || !handle) {
        hideSlot(container, slot);
        container.classList.remove("swatch-qv-atc-pending");
        LOG("Non-swatch QV => OG content shown", reason);
        return;
      }

      let html = card.__swatchQvHtml;
      if (!html) html = await fetchQuickAdd(handle);
      if (!html) return WRN("Could not load swatch quickview markup for:", handle);

      slot.innerHTML = html;
      showSlot(container, slot);

      // make sure we're not in pending state
      container.classList.remove("swatch-qv-atc-pending");

      document.dispatchEvent(new CustomEvent("quickview:content:replaced", { detail: { handle }}));
      LOG("Swatch QV injected + OG hidden", { handle, reason });
    }

    // theme loads drawer content async; apply a few times
    setTimeout(() => apply("t+0"), 0);
    setTimeout(() => apply("t+120"), 120);
    setTimeout(() => apply("t+350"), 350);
  }, true);

  /* =========================
     3) Close / ATC => flash fix
     - Close button: restore OG immediately.
     - Add to cart: keep OG hidden + hide product-form container briefly so OG content can't flash
  ========================== */
  document.addEventListener("click", (e) => {
    const closeBtn = e.target.closest(".layout--close");
    const atcBtn   = e.target.closest(".product-buy-buttons--primary");
    if (!closeBtn && !atcBtn) return;

    const container = document.querySelector(OG_CONTAINER_SEL);
    if (!container) return;

    const slot = container.querySelector("#" + SLOT_ID);
    const swatchModeActive =
      container.classList.contains("swatch-qv-hide-og") ||
      (slot && slot.classList.contains("is-active"));

    // Close button: restore OG immediately
    if (closeBtn) {
      hideSlot(container, slot);
      container.classList.remove("swatch-qv-atc-pending");
      return;
    }

  }, true);

  /* =========================
     4) When drawer closes / overlay removed, reset pending state
     (prevents getting "stuck" hidden)
  ========================== */
  new MutationObserver(() => {
    const container = document.querySelector(OG_CONTAINER_SEL);
    if (!container) return;
    // if overlay is hidden/aria-hidden=true, drawer is closing/closed
    const overlay = document.querySelector(".drawer--overlay");
    const overlayHidden = overlay && overlay.getAttribute("aria-hidden") === "true";
    if (overlayHidden) {
      container.classList.remove("swatch-qv-atc-pending");
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  LOG("Installed combined: swatch updates + OG QV slot injection toggling + badge sync + ATC flash fix.");

})();

/* =========================
    Hide DNS string in footer
========================== */

document.querySelectorAll('.footer-about li a').forEach(a => {
  a.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(
        /"?\s*data-item="nav-text--sub"\s*>\s*\s*/g,
        ''
      );
    }
  });
});





